// Redux Form
import { reset } from "redux-form";
import { addPayout } from "../../../actions/Payout/addPayoutAction";
import showToaster from "../../../helpers/showToaster";
import { containsMalicious } from "../../../helpers/textRestriction";

async function submit(values, dispatch) {
  let paymentType = values.methodId;

  // PayPal
  let payEmail = paymentType == 1 ? values.payEmail : values.email;

  // Stripe
  let firstname = paymentType == 2 ? values.firstname : null;
  let lastname = paymentType == 2 ? values.lastname : null;
  let accountNumber = paymentType == 2 ? values.accountNumber : null;
  let routingNumber = paymentType == 2 ? values.routingNumber : null;
  let ssn4Digits = paymentType == 2 ? values.ssn4Digits : null;
  let businessType = paymentType == 2 ? values.businessType : null;

  // Validate Stripe token
  if (paymentType === 2 && !values.isTokenGenerated) {
    return;
  }

  // Server-side input validation
  const fieldsToValidate = {
    payEmail,
    address1: values.address1,
    address2: values.address2,
    city: values.city,
    state: values.state,
    country: values.country,
    zipcode: values.zipcode,
    currency: values.currency,
    firstname,
    lastname,
    accountNumber,
    routingNumber,
    ssn4Digits,
  };

  for (const [fieldName, fieldValue] of Object.entries(fieldsToValidate)) {
    if (fieldValue && containsMalicious(fieldValue)) {
      showToaster({
        messageId: "invalidInput",
        toasterType: "error",
        requestContent: `Invalid characters in field: ${fieldName}`,
      });
      return;
    }
  }

  dispatch(
    addPayout(
      values.methodId,
      payEmail,
      values.address1,
      values.address2,
      values.city,
      values.state,
      values.country,
      values.zipcode,
      values.currency,
      firstname,
      lastname,
      accountNumber,
      routingNumber,
      ssn4Digits,
      businessType,
      values.userId,
      values.accountToken,
      values.personToken
    )
  );
}

export default submit;
